import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image102 from "../../../../assets/images/Blog53/image102.png";
import image2 from "../../../../assets/images/Blog53/image2.png";
import image31 from "../../../../assets/images/Blog53/image31.png";
import image21 from "../../../../assets/images/Blog53/image21.png";
import image17 from "../../../../assets/images/Blog53/image17.png";
import image8 from "../../../../assets/images/Blog53/image8.png";
import image9 from "../../../../assets/images/Blog53/image9.png";
import image6 from "../../../../assets/images/Blog53/image6.png";
import image7 from "../../../../assets/images/Blog53/image7.png";
import image74 from "../../../../assets/images/Blog53/image74.png";
import image69 from "../../../../assets/images/Blog53/image69.png";
import image40 from "../../../../assets/images/Blog53/image40.png";
import image41 from "../../../../assets/images/Blog53/image41.png";
import image20 from "../../../../assets/images/Blog53/image20.png";
import image77 from "../../../../assets/images/Blog53/image77.png";
import image85 from "../../../../assets/images/Blog53/image85.png";
import image96 from "../../../../assets/images/Blog53/image96.png";
import image99 from "../../../../assets/images/Blog53/image99.png";
import image92 from "../../../../assets/images/Blog53/image92.png";
import image103 from "../../../../assets/images/Blog53/image103.png";
const Blog53 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – January 26, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Growth Still Leads, Rotation Deepens, Volatility Lurks</p>
        <p>
          Markets enter the week with a familiar tone: constructive, but increasingly selective. Despite a steady flow of geopolitical, policy, and rates-related headlines, price action has remained
          broadly contained. Drawdowns have been shallow, rebounds have been orderly, and liquidity continues to circulate rather than retreat.
        </p>
        <p>
          That stability, however, masks a more nuanced internal picture. Positioning has shifted, leadership has rotated, and hedging remains uneven. Expectations have adjusted higher while
          protection has not kept pace, leaving markets more sensitive to surprises even as the broader growth narrative remains intact.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Rotation Without Capitulation</p>
              <p>
                Equity structure remains intact, but progress is no longer driven by uniform momentum. Leadership rotation continues to define tape action, with selling pressure concentrated in
                crowded mega-cap exposures while broader participation absorbs flows more effectively. This has kept headline indices range-bound rather than broken.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt="Growth Trumps everything1"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image31}
                    alt="MAGS oversold now rockets on standby?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image31)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Importantly, this redistribution of leadership reflects <span className="highlightedText">reallocation, not exit.</span> Institutional selling has been visible, particularly in
                high-weight names, yet there is little evidence of broad de-risking. The lack of aggressive downside hedging reinforces that risk is being managed rather than abandoned.
              </p>
              <p>
                Growth remains the primary anchor underpinning this structure. US economic data continues to surprise positively, supporting earnings expectations and cushioning equities against
                episodic volatility driven by headlines rather than fundamentals.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt=" Eco surprise in US still surging"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt="GDPNow mix on track"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Loud Headlines, Measured Response</p>
              <p>
                Geopolitics has reasserted itself as a persistent source of noise. Greenland-related tensions and Arctic security considerations have drawn attention, but market reactions suggest
                these developments are being treated as conditional rather than systemic risks.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt="I want Greenland sulk"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="is it the Arctic trade route or security or both?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Domestically, renewed government shutdown concerns briefly lifted volatility and downside protection. However, the response across rates and equities remained contained, reinforcing
                the view that policy risk is being acknowledged but not fully priced.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="shutdown risks again"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt="govt shutdown odds surge"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Japan continues to sit at the centre of global macro sensitivity. Rising JGB yields and increased volatility have revived carry trade concerns, with FX markets reacting quickly to both
                policy rhetoric and intervention risk. These dynamics keep global rates and currency markets on alert.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image74}
                    alt="JGB vol up = big price moves ahead"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image74)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image69}
                    alt="UJ intervention?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image69)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>
                From a technical perspective, trend structure remains functional. Major indices continue to hold key levels, and recent pullbacks have been corrective rather than impulsive. However,
                momentum has slowed, and dispersion beneath the surface has increased.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image40}
                    alt="SPX sentiment looking DOJI"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image40)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Sentiment data highlights a growing imbalance. Confidence remains elevated in single-stock opportunities, while demand for index-level protection has increased. This reflects a market
                that is optimistic in parts but cautious in aggregate, raising sensitivity to earnings outcomes and macro surprises.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image41}
                    alt="single stock skew sees earnings upside but at extreme bullishness"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image41)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Volatility remains compressed overall, yet this calm sits alongside elevated geopolitical and policy risk. Short gamma dynamics suggest that any unexpected shock could result in
                sharper, faster moves than recent price action implies, increasing intraday risk even as trends hold.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Growth Holds, Cross-Currents Build</p>
              <p>
                Markets navigated last week with resilience, absorbing geopolitical shocks and policy noise without material structural damage. Data, flows, and positioning continued to matter more
                than headlines, even as familiar pressure points remained unresolved.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>US growth data remained constructive. GDP tracking, consumption trends, and corporate profitability reinforced the broader growth narrative, while economic surprise
                    indicators continued to move higher, helping anchor risk assets.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image17}
                        alt="GDPNow mix on track"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image17)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image21}
                        alt="Eco surprise in US still surging"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image21)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br></br>Chinese data remained mixed. While headline growth targets were met, underlying consumption weakness and subdued imports highlighted ongoing structural challenges,
                    limiting the global growth impulse and reinforcing regional divergence.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image20}
                        alt="China GDP mixed data"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image20)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br>Early earnings results were broadly consistent with historical patterns, with a healthy proportion of beats but clear sector dispersion. Financials lagged expectations in
                    places, while attention increasingly turns to large-cap technology for confirmation of broader market strength.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>
                    <br></br>Precious metals continued to attract strong inflows. Gold benefited from debasement concerns and institutional demand, while silver’s strength reflected a combination of
                    industrial demand and speculative interest.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image77}
                      alt="gold weekly close boost"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image77)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image85}
                      alt=" silver tops $100"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image85)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br>Crypto assets continued to underperform relative to hard assets. Price action reflects sensitivity to US-centric political dynamics and competition from traditional stores
                    of value rather than renewed speculative excess.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image96}
                      alt="Stores of value v fiat"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image96)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image99}
                      alt="Stablecoins the Treasury play."
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image99)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br>Oil prices remained supported by geopolitical risk and supply considerations. However, price action suggested consolidation rather than acceleration, with risk premia
                    fluctuating alongside headlines.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image92}
                        alt="Crude up on geo"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image92)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                This week is unusually dense, with a heavy concentration of
                <span className="highlightedText"> earnings, central bank decisions, inflation data, and auctions.</span> With positioning already sensitive, the breadth of scheduled risk raises the
                probability of volatility clustering rather than isolated reactions.
              </p>
              <p className="highlightedText">Monday, January 26</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Coincident Indicator, Leading Index
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> German Ifo Business Climate, Expectations, Current Assessment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Durable Goods Orders, Core Durable Goods
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Chicago Fed National Activity Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Atlanta Fed GDPNow Update
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Treasury Bill Auctions (3M, 6M)
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, January 27</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> BoJ Core CPI, Monetary Policy Meeting Minutes
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Industrial Profits
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Consumer Confidence
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> House Price Indices
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Richmond Fed Manufacturing & Services
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> M2 Money Supply
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> API Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> 5-Year Treasury Auction
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span> UnitedHealth, General Motors, UPS, Boeing, American Airlines
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, January 28</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> CPI (Quarterly & Monthly Indicators)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> MBA Mortgage Applications
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> Bank of Canada Rate Decision, Monetary Policy Report, Press Conference
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Federal Reserve Rate Decision, Statement & Press Conference
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> 7-Year Treasury Auction
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Foreign Bond & Equity Flows
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span> Microsoft, Tesla, AT&T, Starbucks
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, January 29</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Tokyo CPI, Unemployment Rate, Industrial Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> Business & Consumer Surveys, Money Supply, Loans Data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Jobless Claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Trade Balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Factory Orders
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Atlanta Fed GDPNow Update
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Federal Reserve Balance Sheet
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span> Apple, Mastercard, Caterpillar, Lockheed Martin
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, January 30</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Retail Sales, Housing Starts
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> GDP (Germany, France, Italy, Euro Area)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> CPI (Germany, Spain)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> Mortgage Approvals, Credit Data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> GDP
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> PPI (Headline & Core), Chicago PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Michigan Consumer Sentiment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Manufacturing & Services PMIs
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span> Chevron, Exxon, American Express
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image102}
                    alt="week ahead 260126"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image102)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image103}
                    alt="US data week ahead summary"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image103)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Constructive Structure, Narrowing Margin for Error</p>
              <p>
                Markets remain supported by growth and liquidity, but positioning has become more sensitive as volatility stays compressed and protection remains limited. The environment continues to
                reward selectivity over broad exposure.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Rotation continues to dominate equity performance. Broad participation supports the overall structure, but leadership remains selective, increasing the importance of
                    positioning and timing.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Precious metals remain underpinned by geopolitical and macro uncertainty. While positioning may introduce near-term
                    volatility, underlying demand remains resilient.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Crypto continues to lag hard assets, reflecting uneven conviction and sensitivity to political and policy narratives
                    rather than a breakdown in structure.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br> Growth resilience and contained inflation pressures continue to define the backdrop, even as geopolitical and policy
                    risks increase the market’s reactivity to surprises.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">The structure remains constructive, but tolerance for shocks is narrowing. Calm conditions persist, yet they rest on increasingly thin protection.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt="Growth Trumps everything1"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image77}
                    alt="hot gold flows"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image77)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image40}
                    alt="SPX sentiment looking DOJI"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image40)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1LIzt5RHX-FYRhDXcRY3OYpQEERv4z4dkxcnuAcMH9RU/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog53;
